import { connect } from 'react-redux';

import { IReduxState, TThunkDispatch } from '../../types/redux';
import { FDealType } from '../../utils/category';
import { setDealType } from '../../actions/filters';
import { FiltersTabs, IFiltersTabsProps } from '../../components/FiltersTabs';

type TFiltersTabsStateProps = Pick<IFiltersTabsProps, 'jsonQuery'>;
type TFilterOfferTypeDispatchProps = Pick<IFiltersTabsProps, 'onDealTypeSelect'>;

function mapStateToProps(state: IReduxState): TFiltersTabsStateProps {
  return {
    jsonQuery: state.filters.jsonQuery,
  };
}

function mapDispatchToProps(dispatch: TThunkDispatch): TFilterOfferTypeDispatchProps {
  return {
    onDealTypeSelect: (dealType: FDealType) => dispatch(setDealType(dealType)),
  };
}

export const FiltersTabsContainer = connect(mapStateToProps, mapDispatchToProps)(FiltersTabs);
